export default function Triskelion({ className = "w-8 h-8", strokeWidth = 7 }) {
  // The Three Legs of Man — three armoured legs joined at the hip, bent at the knee,
  // feet pointing clockwise, rendered in the same line style/size as the old mark.
  const leg = "M50 50 L50 26 L65 33";
  return (
    <svg viewBox="0 0 100 100" className={className} aria-label="Three Legs of Man" role="img">
      <g stroke="currentColor" fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        <path d={leg} />
        <path d={leg} transform="rotate(120 50 50)" />
        <path d={leg} transform="rotate(240 50 50)" />
        {/* feet */}
        <path d="M65 33 L61 41" />
        <path d="M65 33 L61 41" transform="rotate(120 50 50)" />
        <path d="M65 33 L61 41" transform="rotate(240 50 50)" />
      </g>
      <circle cx="50" cy="50" r="4.5" fill="currentColor" />
    </svg>
  );
}
